import { useEffect, useState } from "react";
import type { PictureConfig } from "../engine/lessonTypes";
import { PictureContent } from "./PictureContent";
import styles from "./LessonView.module.css";

interface PictureDemoViewProps extends PictureConfig {
  onFinished: () => void;
}

export function PictureDemoView({
  images,
  labels,
  onFinished,
}: PictureDemoViewProps) {
  const [revealed, setRevealed] = useState(0);

  useEffect(() => {
    if (revealed >= images.length) {
      const done = setTimeout(() => onFinished(), 800);
      return () => clearTimeout(done);
    }
    const timer = setTimeout(() => setRevealed((value) => value + 1), 1800);
    return () => clearTimeout(timer);
  }, [revealed, images.length, onFinished]);

  return (
    <div className={styles.lesson}>
      <div className={styles.pictures}>
        {images.map((source, index) => (
          <div className={styles.pictureItem} key={index}>
            <div className={styles.pictureButton}>
              <PictureContent
                source={source}
                alt={labels[index]?.replace(/<[^>]+>/g, "") ?? ""}
              />
            </div>
            {index < revealed ? (
              <span
                className={styles.pictureLabel}
                dangerouslySetInnerHTML={{ __html: labels[index] ?? "" }}
              />
            ) : (
              <span className={styles.pictureLabel}>&nbsp;</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
